/* global charmDefault */
class PersonalizerInline extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    // write element functionality in here
    this.setData();
    this.getElement();
    this.addEventListeners();
    this.getLettersDefault();
  }

  setData() {
    this.config = {
      showClass: "show",
    };
    this.properties = {};
    this.letterValues = [];
  }

  getElement() {
    this.colorEls = document.querySelectorAll(".js-color-item");
    this.mediaGalleryEl = document.querySelector(".js-media-gallery");
    this.gridGalleryDesktopEl = document.querySelector(".js-grid-gallery-desktop");
    this.colorMessageEl = this.querySelector('.js-color-message')
    this.chainCurrentEl = document.querySelector(".js-chain-current");
    this.chainItemEls = document.querySelectorAll(".js-chain-item");
    this.letterEls = document.querySelectorAll(".js-personalizer-letter");
    this.previewEl = document.querySelector(".js-preview");
    this.previewOptionsEl = document.querySelector(".js-preview-options");
    this.buttonAtcEl = document.querySelector(".js-button-atc");
    this.offerModalEl = document.querySelector(".js-offer-modal");
    this.offsetTopError = 300;
    this.extraItems = [];
    this.meaningItems = [];
    this.productHandle = this.dataset.productHandle;
  }

  // handleize text to lowercase and replace spaces with hyphens
  handleize(text) {
    return text?.toLowerCase()?.replace(/\s+/g, '-');
  }

  addEventListeners() {
    this.colorEls?.forEach((el) => {
      el.addEventListener("click", (event) => {
        const activeEl = this.querySelector(".js-color-item.active");
        if (activeEl) {
          activeEl.classList.remove("active");
        }
        el.classList.add("active");

        const colorStepEl = this.querySelector(".personalizer-color-inline")?.closest(".personalizer-inline__step");
        if (colorStepEl) {
          colorStepEl.classList.remove("personalizer__step-error");
        }

        if (this.colorMessageEl) {
          this.colorMessageEl.setAttribute('data-color', el.dataset.color)
        }

        // Navigate mobile media gallery to matching color slide
        if (this.mediaGalleryEl) {
          const slides = this.mediaGalleryEl.querySelectorAll("swiper-slide");
          const targetIndex = Array.from(slides).findIndex(
            (slide) => this.handleize(slide.dataset.mediaAlt) === this.handleize(el.dataset.color)
          );
          if (targetIndex !== -1 && this.mediaGalleryEl.swiper) {
            this.mediaGalleryEl.swiper.slideTo(targetIndex);
          }
        }

        // Reorder desktop grid gallery to show matching color first via CSS order
        if (this.gridGalleryDesktopEl) {
          const items = this.gridGalleryDesktopEl.children;
          // Find the first item that matches the color then remove all class media-item--first in other items
          const matchingItem = Array.from(items).find(
            (item) => this.handleize(item.dataset.mediaAlt) === this.handleize(el.dataset.color)
          );
          if (matchingItem) {
            matchingItem.classList.add("media-item--first");
            Array.from(items).forEach((item) => {
              if (item !== matchingItem) {
                item.classList.remove("media-item--first");
              }
            });
          }

        }
      });
    });

    this.chainCurrentEl?.addEventListener(
      "click",
      this.handleChainClick.bind(this)
    );

    this.chainItemEls?.forEach((el) => {
      el.addEventListener("click", () => {
        this.handleChainItemClick(el);
      });
    });

    document.addEventListener("zodiacChange", (e) => {
      const item = e.detail.item
      const index = parseInt(item.dataset.index);
      const value = item.dataset.value;
      this.handleLetterClick(index, value);
    });

    this.letterEls?.forEach((el) => {
      el.addEventListener("change", (event) => {
        this.handleLetterClick(event.target.dataset.index, event.target.value);
      });
    });

    this.buttonAtcEl?.addEventListener(
      "click",
      this.handleButtonAtcClick.bind(this)
    );

    // document.addEventListener("openCustomize", (e) => {
    //   this.handleButtonAtcClick();
    // });

    this.stepExtra();
    this.initDateSelection();
  }

  stepExtra() {
    this.extraPreviewEl = this.querySelector(".js-extra-image");
    this.extraCurrentEl = this.querySelector(".js-extra-current");
    this.extraItemEls = this.querySelectorAll(".js-extra-item-word");
    this.buttonPriceEl = this.querySelector(".js-button-price");
    this.extraStep = this.querySelector(".js-extra-step");

    const type = this.extraStep?.dataset?.type;
    this.extraType = type ?? 'Extra charm';
    this.properties[this.extraType] = '';

    if (type) {
      this.properties[this.extraType] = 'Love';
    }

    this.extraEvent()
  }

  extraEvent() {
    this.extraCurrentEl?.addEventListener(
      "click",
      this.handleExtraClick.bind(this, true)
    );

    this.extraItemEls?.forEach((el) => {
      el.addEventListener("click", () => {
        this.extraStep.classList.remove("personalizer__step-error");
        this.handleExtraItemClick(el);
      });
    });

    const _this = this;
    const handleExtraCartItemUpdate = () => {
      _this.extraItems = [];
      const extraItemsEls = _this.querySelectorAll(`.js-extra-item.selected`);

      extraItemsEls.forEach((extraItem) => {
        const variantId = extraItem.dataset.variant;
        const itemCart = {
          id: variantId,
          properties: {},
          quantity: 1,
        }
        _this.extraItems = [
          ..._this.extraItems,
          itemCart,
        ]
      });
    };
    const handleMeaningCartItemUpdate = () => {
      _this.meaningItems = [];
      const meaningItemsEls = _this.querySelectorAll(`.js-extra-meaning-card-inline.selected`);

      meaningItemsEls.forEach((meaningItem) => {
        const variantId = meaningItem.dataset.variant;
        const itemCart = {
          id: variantId,
          properties: {},
          quantity: 1,
        }
        _this.meaningItems = [
          ..._this.meaningItems,
          itemCart,
        ]
      });
    };

    this.addEventListener("updateExtraCartItem", handleExtraCartItemUpdate);
    this.addEventListener("meaningCart", handleMeaningCartItemUpdate);

    this.addEventListener("updateProperties", (e) => {
      const properties = e.detail.properties;
      this.properties = {
        ...this.properties,
        ...properties,
      }
      // null = "remove this property" (a birthstone that was deselected)
      Object.keys(properties || {}).forEach((k) => { if (properties[k] === null) delete this.properties[k]; });
    });


    document.addEventListener("extraSelected", (e) => {
      if (this.extraPreviewEl) {
        this.extraPreviewEl.parentElement.style.display = "none";
      }

    });
  }
  handleExtraClick(show = true) {
    if (show) {
      this.extraCurrentEl?.nextElementSibling?.classList?.add(
        this.config?.showClass || "show"
      );
    } else {
      this.extraCurrentEl?.nextElementSibling?.classList?.remove(
        this.config?.showClass || "show"
      );
    }
  }

  handleExtraItemClick(item) {
    this.extraItemEls?.forEach((el) => {
      el.classList.remove("active");
    });
    item.classList.add("active");

    if (this.extraCurrentEl.querySelector("img")) {
      this.extraCurrentEl.querySelector("img").src = item.dataset.icon;
    }
    this.extraCurrentEl.querySelector("span").innerText = item.dataset.name;

    if (this.extraPreviewEl) {
      if (item.dataset.image) {
        this.extraPreviewEl.src = item.dataset.image;
        this.extraPreviewEl.parentElement.style.display = "block";
      } else {
        this.extraPreviewEl.parentElement.style.display = "none";
      }
    }

    this.properties[this.extraType] = item.dataset.value;
    this.handleExtraClick(false);
    this.extraVariant = item.dataset.variant;
  }

  handleChainClick() {
    this.chainCurrentEl?.nextElementSibling?.classList?.toggle(
      this.config?.showClass || "show"
    );
  }

  handleChainItemClick(item) {
    this.chainItemEls?.forEach((el) => {
      el.classList.remove("active");
    });
    item.classList.add("active");

    this.chainCurrentEl.querySelector("img").src = item.dataset.image;
    this.chainCurrentEl.querySelector("span").innerText = item.dataset.chain;
    this.handleChainClick();
  }

  getLettersDefault() {
    this.letterEls?.forEach((el, index) => {
      const letter = el.dataset.letter;
      const value = el.value;
      this.letterValues[index] = value;
    });
    this.renderPreview();
  }

  handleLetterClick(index, value) {
    this.letterValues[index] = value;
    this.renderPreview();
  }

  renderPreview() {
    const letterTitles = [this.letterValues.join(" + ").toLocaleLowerCase()];

    if (typeof propertyPreview !== "undefined" && propertyPreview === "Letters") {
      const letterArray = [...this.letterValues];
      letterTitles.push(letterArray?.reverse().join(" + ").toLocaleLowerCase());
    }

    if (typeof previews !== "undefined") {
      const preview = previews.find((letter) =>
        letterTitles.includes(letter.title.toLocaleLowerCase())
      );

      const previewValue = this.querySelector('.js-preview-value')

      if (preview && preview.image) {
        const imageV1 = this.querySelector(".js-preview-option[data-preview-option='1']");
        const imageV2 = this.querySelector(".js-preview-option[data-preview-option='2']");
        const imageV3 = this.querySelector(".js-preview-option[data-preview-option='3']");

        const previewOptions = this.querySelectorAll('[name="preview-option"]')
        previewOptions.forEach((option) => {
          option.addEventListener('change', () => {
            previewValue.value = option.value
          })
        })

        if (preview.image_v2 && preview.image_v3) {
          this.previewEl.src = "";
          imageV1.src = preview.image;
          imageV2.src = preview.image_v2;
          imageV3.src = preview.image_v3;

          previewValue.value = this.querySelector('[name="preview-option"]:checked').value ?? "v1"
          this.previewOptionsEl.style.display = 'block'
        } else {
          imageV1.src = "";
          imageV2.src = "";
          imageV3.src = "";
          this.previewEl.src = preview.image;

          previewValue.value = ""
          this.previewOptionsEl.style.display = 'none'
        }
      } else {
        this.previewEl.src = "";
      }
    }
  }

  validateExtra() {
    if (this.properties[this.extraType] === "") {
      this.extraStep.classList.add("personalizer__step-error");
      return false;
    }
    this.extraStep.classList.remove("personalizer__step-error");
    return true;
  }

  validateZodiac() {
    const zodiacEls = this.querySelectorAll(".js-select");
    let isValid = true;

    zodiacEls.forEach((el) => {
      const value = el.querySelector(".js-select-value").dataset.value;
      if (!value) {
        el.classList.add("custom-select--error");
        isValid = false;
      } else {
        el.classList.remove("custom-select--error");
      }
    });

    return isValid;
  }

  validateExtraAtc() {
    const validateEls = this.querySelectorAll(".js-validation");

    if (validateEls.length === 0) {
      return false;
    }

    let hasError = false;
    validateEls.forEach((el) => {
      const selectEl = el.querySelector(".js-select");
      const valueSelected = selectEl.querySelector(".js-select-value").dataset.value;
      if (!valueSelected) {
        hasError = true;
        el.classList.add("custom-select--error");
      } else {
        el.classList.remove("custom-select--error");
      }
    });

    return hasError;
  }

  validateExtraAtcDefault() {
    if (this.extraItemEls?.length) {
      const validate = this.validateExtra()
      const validateZodiac = this.validateZodiac()

      if (!validate || !validateZodiac) {
        if (!validateZodiac) {
          // Keep the earliest error position (smallest value) when multiple validations fail
          this.offsetTopError = Math.min(this.offsetTopError || Infinity, 90);
        }

        return true;
      }
    }

    return false;
  }

  /**
   * Validates that at least one date field (month, day, or year) is selected.
   * @returns {boolean} Returns true if validation fails (error), false if validation passes.
   *                   This pattern matches validateExtraAtc() for consistency.
   */
  validateDate() {
    const monthSelect = this.querySelector(".js-date-month");
    const daySelect = this.querySelector(".js-date-day");
    const yearSelect = this.querySelector(".js-date-year");

    // If date fields are not present, validation passes
    if (!monthSelect || !daySelect || !yearSelect) {
      return false; // No date fields present, validation passes
    }

    // Check each date field for its specific data attribute
    const monthValue = monthSelect.querySelector(".js-select-value")?.dataset.month || "";
    const dayValue = daySelect.querySelector(".js-select-value")?.dataset.day || "";
    const yearValue = yearSelect.querySelector(".js-select-value")?.dataset.year || "";

    // At least one date field must be selected
    const hasSelection = (monthValue && monthValue !== "") ||
                         (dayValue && dayValue !== "") ||
                         (yearValue && yearValue !== "");

    const monthSelectEl = monthSelect.querySelector(".js-select");
    const daySelectEl = daySelect.querySelector(".js-select");
    const yearSelectEl = yearSelect.querySelector(".js-select");

    if (!hasSelection) {
      // No field selected - show error on all fields
      monthSelectEl?.classList.add("custom-select--error");
      daySelectEl?.classList.add("custom-select--error");
      yearSelectEl?.classList.add("custom-select--error");

      const dateStep = this.querySelector(".js-date-step");
      if (dateStep) {
        const newOffset = dateStep.offsetTop - 100;
        // Keep the earliest error position (smallest value) when multiple validations fail
        this.offsetTopError = Math.min(this.offsetTopError || Infinity, newOffset);
      }

      return true; // true = error, false = valid
    } else {
      // At least one field selected - remove error from all fields
      monthSelectEl?.classList.remove("custom-select--error");
      daySelectEl?.classList.remove("custom-select--error");
      yearSelectEl?.classList.remove("custom-select--error");

      return false; // Validation passes
    }
  }

  initDateSelection() {
    const monthSelect = this.querySelector(".js-date-month");
    const daySelect = this.querySelector(".js-date-day");
    const yearSelect = this.querySelector(".js-date-year");

    if (!monthSelect || !daySelect || !yearSelect) {
      // Date selection not present on this page - this is expected for non-date products
      return;
    }

    // Generate year options dynamically for performance
    this.initYearOptions(yearSelect);

    // Listen for month/year changes to update day dropdown
    const updateDayOptions = () => {
      const monthValue = monthSelect.querySelector(".js-select-value")?.dataset.month || "";
      const yearValue = yearSelect.querySelector(".js-select-value")?.dataset.year || "";
      const dayValue = daySelect.querySelector(".js-select-value")?.dataset.day || "";

      if (!monthValue) {
        // Reset to 31 days if no month selected
        this.updateDayDropdown(31);
        return;
      }

      const monthNum = parseInt(monthValue, 10);
      let daysInMonth = 31;

      if (monthNum === 2) {
        // February - check leap year
        if (yearValue) {
          const yearNum = parseInt(yearValue, 10);
          const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || (yearNum % 400 === 0);
          daysInMonth = isLeapYear ? 29 : 28;
        } else {
          daysInMonth = 29; // Default to 29 if year not selected
        }
      } else if ([4, 6, 9, 11].includes(monthNum)) {
        // April, June, September, November
        daysInMonth = 30;
      }

      // If a day is already selected, validate it against the new month/year
      if (dayValue && monthValue) {
        const dayNum = parseInt(dayValue, 10);
        const monthNum = parseInt(monthValue, 10);

        let shouldReset = false;

        // If year is also selected, do full date validation
        if (yearValue) {
          const yearNum = parseInt(yearValue, 10);
          const isValid = this.isValidDate(monthNum, dayNum, yearNum);
          shouldReset = !isValid;
        } else {
          // If no year, just check if day is valid for the month (e.g., day 31 in April)
          shouldReset = dayNum > daysInMonth;
        }

        if (shouldReset) {
          // Invalid date (e.g., Feb 29 in non-leap year, or day 31 in April)
          // Reset the day selection
          const daySelectValue = daySelect.querySelector(".js-select-value");
          if (daySelectValue) {
            daySelectValue.setAttribute("data-value", "");
            daySelectValue.setAttribute("data-day", "");
            const span = daySelectValue.querySelector("span");
            if (span) span.textContent = "None";
          }
        }
      }

      this.updateDayDropdown(daysInMonth);
      this.updateRomanDisplay();
    };

    // Listen for dateChange events from CustomSelectDate
    monthSelect.addEventListener("dateChange", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(updateDayOptions);
      });
    });

    yearSelect.addEventListener("dateChange", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(updateDayOptions);
      });
    });

    // Listen for all date field changes to update Roman display
    [monthSelect, daySelect, yearSelect].forEach((select) => {
      select.addEventListener("dateChange", () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.updateRomanDisplay());
        });
      });
    });

    // Initial update
    updateDayOptions();

    // Display current date in Roman numerals on page load
    this.displayCurrentDate();
  }

  initYearOptions(yearSelect) {
    const yearList = yearSelect.querySelector(".js-year-list");
    if (!yearList) return;

    // Check if options already exist (avoid duplicate generation)
    if (yearList.querySelectorAll(".js-year-option").length > 0) {
      return;
    }

    // Set up event delegation for dynamically created options (prevents memory leaks)
    // Use a single listener on the container instead of individual listeners on each option
    if (!yearList.hasAttribute("data-delegation-setup")) {
      yearList.addEventListener("click", (event) => {
        const option = event.target.closest(".js-option");
        if (option && yearList.contains(option)) {
          yearSelect.handleOptionClick(option);
        }
      });
      yearList.setAttribute("data-delegation-setup", "true");
    }

    const thumbnailDefault = yearList.querySelector(".js-option")?.querySelector("img")?.src || "";
    const yearStart = 1901;
    const yearEnd = 2036;

    // Generate year options
    for (let year = yearStart; year <= yearEnd; year++) {
      const option = document.createElement("div");
      option.className = "custom-select__item js-option js-year-option";
      option.setAttribute("data-name", year.toString());
      option.setAttribute("data-value", year.toString());
      option.setAttribute("data-year", year.toString());
      option.setAttribute("data-icon", thumbnailDefault);

      const span = document.createElement("span");
      span.className = "custom-select__item-text";
      span.textContent = year.toString();

      option.appendChild(span);
      yearList.appendChild(option);
    }
  }

  updateDayDropdown(maxDays) {
    // Validate component is still connected
    if (!this.isConnected) return;

    // Validate maxDays is a valid number
    const maxDaysNum = parseInt(maxDays, 10);
    if (isNaN(maxDaysNum) || maxDaysNum < 1 || maxDaysNum > 31) {
      return;
    }

    const dayList = this.querySelector(".js-day-list");
    if (!dayList) return;

    const dayOptions = dayList.querySelectorAll(".js-day-option");
    if (dayOptions.length === 0) return;

    const currentDayValue = this.querySelector(".js-date-day .js-select-value")?.dataset.day || "";

    dayOptions.forEach((option, index) => {
      // Validate option is still in DOM
      if (!option.isConnected) return;

      const dayNum = index + 1;
      if (dayNum <= maxDaysNum) {
        option.style.display = "";
      } else {
        option.style.display = "none";
        // If current selection is beyond max days, reset to "None"
        if (currentDayValue && parseInt(currentDayValue, 10) > maxDaysNum) {
          const daySelectValue = this.querySelector(".js-date-day .js-select-value");
          if (daySelectValue && daySelectValue.isConnected) {
            daySelectValue.setAttribute("data-value", "");
            daySelectValue.setAttribute("data-day", "");
            const span = daySelectValue.querySelector("span");
            if (span) span.textContent = "None";
          }
        }
      }
    });
  }

  convertToRoman(num) {
    if (!num || num === "" || num === "0") return "";

    const n = parseInt(num, 10);
    if (isNaN(n) || n <= 0) return "";

    const values = [
      { value: 1000, numeral: "M" },
      { value: 900, numeral: "CM" },
      { value: 500, numeral: "D" },
      { value: 400, numeral: "CD" },
      { value: 100, numeral: "C" },
      { value: 90, numeral: "XC" },
      { value: 50, numeral: "L" },
      { value: 40, numeral: "XL" },
      { value: 10, numeral: "X" },
      { value: 9, numeral: "IX" },
      { value: 5, numeral: "V" },
      { value: 4, numeral: "IV" },
      { value: 1, numeral: "I" }
    ];

    let result = "";
    let remaining = n;

    for (const { value, numeral } of values) {
      const count = Math.floor(remaining / value);
      if (count > 0) {
        result += numeral.repeat(count);
        remaining -= value * count;
      }
    }

    return result;
  }

  /**
   * Validates if a date is valid (e.g., prevents February 30, April 31, Feb 29 in non-leap years)
   * @param {number} month - Month (1-12)
   * @param {number} day - Day (1-31)
   * @param {number} year - Year (1901-2036)
   * @returns {boolean} True if the date is valid
   */
  isValidDate(month, day, year) {
    if (!month || !day || !year) return false;

    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);
    const yearNum = parseInt(year, 10);

    // Basic range validation
    if (monthNum < 1 || monthNum > 12) return false;
    if (dayNum < 1 || dayNum > 31) return false;
    if (yearNum < 1901 || yearNum > 2036) return false;

    // Use Date object to validate actual date validity
    // Note: Date uses 0-indexed months, so subtract 1
    const date = new Date(yearNum, monthNum - 1, dayNum);
    return (
      date.getFullYear() === yearNum &&
      date.getMonth() === monthNum - 1 &&
      date.getDate() === dayNum
    );
  }

  convertDateToRoman(month, day, year) {
    const parts = [];

    // If all three values are provided, validate the complete date
    if (month && day && year) {
      if (!this.isValidDate(month, day, year)) {
        // Invalid date combination - return empty string
        return "";
      }
    }

    if (month && month !== "") {
      const monthNum = parseInt(month, 10);
      const monthRomans = ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
      // Validate month range (1-12)
      if (monthNum >= 1 && monthNum <= 12) {
        parts.push(monthRomans[monthNum]);
      }
    }

    if (day && day !== "") {
      const dayNum = parseInt(day, 10);
      // Validate day range (1-31)
      if (dayNum >= 1 && dayNum <= 31) {
        parts.push(this.convertToRoman(day));
      }
    }

    if (year && year !== "") {
      const yearNum = parseInt(year, 10);
      // Validate year range (1901-2036) to match dropdown options
      if (yearNum >= 1901 && yearNum <= 2036) {
        parts.push(this.convertToRoman(year));
      }
    }

    return parts.length > 0 ? parts.join(".") : "";
  }

  displayCurrentDate() {
    const displayEl = this.querySelector(".js-roman-display");
    if (!displayEl) return;

    const today = new Date();
    const month = today.getMonth() + 1; // 0-indexed to 1-indexed
    const day = today.getDate();
    const year = today.getFullYear();

    // Validate year is in range
    if (year < 1901 || year > 2036) return;

    // Convert to Roman numerals and update display only
    const romanDate = this.convertDateToRoman(month.toString(), day.toString(), year.toString());
    if (romanDate) {
      displayEl.textContent = romanDate;
      displayEl.setAttribute("data-roman", romanDate);
    }
  }

  updateRomanDisplay() {
    const monthValue = this.querySelector(".js-date-month .js-select-value")?.dataset.month || "";
    const dayValue = this.querySelector(".js-date-day .js-select-value")?.dataset.day || "";
    const yearValue = this.querySelector(".js-date-year .js-select-value")?.dataset.year || "";

    const romanDate = this.convertDateToRoman(monthValue, dayValue, yearValue);
    const displayEl = this.querySelector(".js-roman-display");

    if (displayEl) {
      // Only update DOM if the value actually changed
      const currentValue = displayEl.getAttribute("data-roman") || "";
      const newValue = romanDate || "";

      if (currentValue !== newValue) {
        if (romanDate) {
          displayEl.textContent = romanDate;
          displayEl.setAttribute("data-roman", romanDate);
        } else {
          displayEl.textContent = "--";
          displayEl.setAttribute("data-roman", "");
        }
      }
    }
  }

  async handleButtonAtcClick() {
    const hasColorItems = this.colorEls?.length > 0;
    const hasColorSelected = this.querySelector(".js-color-item.active");
    if (hasColorItems && !hasColorSelected) {
      const colorStepEl = this.querySelector(".personalizer-color-inline")?.closest(".personalizer-inline__step");
      if (colorStepEl) {
        colorStepEl.classList.add("personalizer__step-error");
      }
      window.scrollTo({
        top: this.offsetTop - 60,
        behavior: 'smooth'
      });
      return;
    }

    const validateExtraAtc = this.validateExtraAtc();
    const validateExtraAtcDefault = this.validateExtraAtcDefault();
    const validateDate = this.validateDate();

    if (validateExtraAtc || validateExtraAtcDefault || validateDate) {

        window.scrollTo({
          top: this.offsetTop + this.offsetTopError,
          behavior: 'smooth'
        })
      return;
    }

    let variantId = this.buttonAtcEl.dataset.variantId;

    if (this.extraVariant) {
      variantId = this.extraVariant;
    }


    const color = this.querySelector(".js-color-item.active")?.dataset.color;
    const chain = this.querySelector(".js-chain-item.active")?.dataset.chain;
    const preview = this.querySelector(".js-preview-value")?.value;

    const properties = {
      Color: color,
      Chain: chain,
      Preview: preview,
    };

    if (typeof propertyPreview !== "undefined" && propertyPreview) {
      properties[propertyPreview] = this.letterValues.join(" + ");
    }

    // Collect date values and convert to Roman numerals
    const dateMonthEl = this.querySelector(".js-date-month .js-select-value");
    const dateDayEl = this.querySelector(".js-date-day .js-select-value");
    const dateYearEl = this.querySelector(".js-date-year .js-select-value");

    if (dateMonthEl || dateDayEl || dateYearEl) {
      const month = dateMonthEl?.dataset.month || "";
      const day = dateDayEl?.dataset.day || "";
      const year = dateYearEl?.dataset.year || "";

      if (month || day || year) {
        const romanDate = this.convertDateToRoman(month, day, year);
        if (romanDate) {
          properties.Date = romanDate;
        }
      }
    }

    this.buttonAtcEl.disabled = true;
    this.buttonAtcEl.textContent = "Adding...";

    const items = [
      ...this.extraItems.map((item) => ({
        ...item,
        properties: {
          ...item.properties,
          _parent: this.productHandle,
        },
      })),
      ...this.meaningItems.map((item) => ({
        ...item,
        properties: {
          ...item.properties,
        },
      })),
      {
        id: variantId,
        properties: {...properties,...this.properties},
        quantity: 1,
      }
    ]

    const data = {
      'items': items
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then(async (data) => {
        this.buttonAtcEl.textContent = "Added to cart";

        // fetch data cart
        // const cartData = await fetch("/cart.js", {
        //   method: "GET",
        //   headers: {
        //     "Content-Type": "application/json",
        //   }
        // })
        // const cartDataJson = await cartData.json()
        // let showOffer = true
        // let mainItem = 0
        // cartDataJson.items.forEach(item => {
        //   if (!item?.properties?._parent && !item?.properties?._card) {
        //     mainItem++
        //   }
        // });
        // if (mainItem % 2 === 0) {
        //   showOffer = false
        // }
        const showOffer = true

        if (this.offerModalEl && showOffer) {
          this.offerModalEl.classList.add("open");

          // fetch data cart
          const cartData = await fetch("/cart.js", {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              }
            })
          const cartDataJson = await cartData.json()
          let mainItem = 0
          cartDataJson.items.forEach(item => {
            if (!item?.properties?._parent && !item?.properties?._card) {
              mainItem = mainItem + item.quantity;
            }
          });
          this.offerModalEl.dispatchEvent(new CustomEvent("update-progress", {
            detail: {
              step: mainItem,
            },
          }));
        } else {
          window.location.href = "/cart";
        }
        this.buttonAtcEl.disabled = false;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("personalizer-inline", PersonalizerInline);

class PersonalizerModal extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    this.getElement();
    this.addEventListeners();
  }

  getElement() {
    this.openButtons = document.querySelectorAll(".js-chain-preview");
    this.buttonClose = this.querySelector(".js-modal-close");
    this.previewImage = this.querySelector(".js-modal-image");
  }

  addEventListeners() {
    this.openButtons?.forEach((el) => {
      el.addEventListener("click", this.handleOpenModal.bind(this));
    });

    this.buttonClose?.addEventListener("click", () => {
      this.classList.remove("open");
    });
  }

  handleOpenModal() {
    const imagePreview = document.querySelector(".js-chain-item.active")
      ?.dataset.image;

    if (!imagePreview) {
      return;
    }

    this.previewImage.src = imagePreview;

    this.previewImage?.addEventListener("load", () => {
      this.classList.add("open");
    });
  }
}

customElements.define("chain-modal", PersonalizerModal);

class PersonalizerOffer extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    this.getElement();
    this.addEventListeners();
  }

  getElement() {
    this.buttonClose = this.querySelector(".js-modal-close");
    this.overlay = this.querySelector(".js-modal-overlay");
    this.offerEls = this.querySelectorAll(".js-button-offer");
  }

  addEventListeners() {
    this.buttonClose?.addEventListener("click", () => {
      this.classList.remove("open");
    });
    this.overlay?.addEventListener("click", () => {
      this.classList.remove("open");
    });

    this.offerEls?.forEach((el) => {
      el.addEventListener("click", () => this.handleOfferClick(el));
    });
  }

  handleOfferClick(_this) {
    const url = _this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  }
}

customElements.define("offer-modal", PersonalizerOffer);

class CustomSelect extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    this.getElement();
    this.addEventListeners();
  }

  getElement() {
    this.selectEl = this.querySelector(".js-select");
    this.optionEls = this.querySelectorAll(".js-option");
    this.selectValueEl = this.querySelector(".js-select-value");
  }

  addEventListeners() {
    this.selectValueEl?.addEventListener("click", this.handleSelectClick.bind(this));
    this.optionEls?.forEach((el) => {
      el.addEventListener("click", this.handleOptionClick.bind(this, el));
    });
  }

  handleSelectClick() {
    this.selectEl?.classList.toggle("open");
  }

  handleOptionClick(item) {
    const name = item.dataset.name;
    const value = item.dataset.value;
    const thumbnail = item.dataset.icon;
    this.selectValueEl.querySelector('span').textContent = name;
    this.selectValueEl?.setAttribute("data-value", value);
    if (this.selectValueEl.querySelector('img')) {
      if (thumbnail) {
        this.selectValueEl.querySelector('img').src = thumbnail;
      } else {
        this.selectValueEl.querySelector('img').src = '';
      }
    }
    this.selectEl?.classList.remove("open");
    this.handleOptionSelected(item);
  }

  handleOptionSelected(item) {}
}

class CustomSelectZodiac extends CustomSelect {
  handleOptionSelected(item) {
    document.dispatchEvent(new CustomEvent("zodiacChange", {
      detail: {
        item,
      },
    }));
  }
}

customElements.define("custom-select-zodiac", CustomSelectZodiac);

class CustomSelectDate extends CustomSelect {
  /**
   * Closes all other date dropdowns (month, day, year) except the current one
   */
  closeOtherDateDropdowns() {
    const personalizerInline = this.closest("personalizer-inline");
    if (!personalizerInline) return;

    const allDateSelects = personalizerInline.querySelectorAll(".js-date-month, .js-date-day, .js-date-year");
    allDateSelects.forEach((select) => {
      if (select !== this) {
        const selectEl = select.querySelector(".js-select");
        selectEl?.classList.remove("open");
      }
    });
  }

  handleSelectClick() {
    // Close other date dropdowns before opening this one
    this.closeOtherDateDropdowns();
    // Toggle the current dropdown
    this.selectEl?.classList.toggle("open");
  }

  handleOptionClick(item) {
    const name = item.dataset.name;
    const value = item.dataset.value;
    const thumbnail = item.dataset.icon;
    this.selectValueEl.querySelector('span').textContent = name;
    this.selectValueEl?.setAttribute("data-value", value);

    // Set the specific date attribute (month, day, or year) based on the select type
    if (this.classList.contains("js-date-month")) {
      const monthValue = item.dataset.month || value;
      this.selectValueEl?.setAttribute("data-month", monthValue);
    } else if (this.classList.contains("js-date-day")) {
      const dayValue = item.dataset.day || value;
      this.selectValueEl?.setAttribute("data-day", dayValue);
    } else if (this.classList.contains("js-date-year")) {
      const yearValue = item.dataset.year || value;
      this.selectValueEl?.setAttribute("data-year", yearValue);
    }

    if (this.selectValueEl.querySelector('img')) {
      if (thumbnail) {
        this.selectValueEl.querySelector('img').src = thumbnail;
      } else {
        this.selectValueEl.querySelector('img').src = '';
      }
    }
    // Close all date dropdowns when an option is selected
    this.closeOtherDateDropdowns();
    this.selectEl?.classList.remove("open");
    this.handleOptionSelected(item);
  }

  handleOptionSelected(item) {
    this.dispatchEvent(new CustomEvent("dateChange", {
      detail: {
        item,
        type: this.classList.contains("js-date-month") ? "month" :
              this.classList.contains("js-date-day") ? "day" : "year",
      },
    }));
  }
}

customElements.define("custom-select-date", CustomSelectDate);
